const plainTypeVariants = {
    primary: '',
    secondary: '',
    critical: ''
};
const plainTypes = Object.keys(plainTypeVariants);
const plainTextStyleVariants = {
    body1: {
        buttonSlot: 'text-body1',
        iconSlot: 'text-icon-24 h-[24px] w-[24px]'
    },
    body2: {
        buttonSlot: 'text-body2',
        iconSlot: 'text-icon-20 h-[20px] w-[20px]'
    },
    body3: {
        buttonSlot: 'text-body3',
        iconSlot: 'text-icon-16 h-[16px] w-[16px]'
    },
    heading4: {
        buttonSlot: 'text-heading4',
        iconSlot: 'text-icon-24 h-[24px] w-[24px]'
    },
    heading5: {
        buttonSlot: 'text-heading5',
        iconSlot: 'text-icon-20 h-[20px] w-[20px]'
    },
    heading6: {
        buttonSlot: 'text-heading6',
        iconSlot: 'text-icon-16 h-[16px] w-[16px]'
    }
};
const plainTextStyles = Object.keys(plainTextStyleVariants);
const plainEmphasisVariants = {
    regular: '',
    medium: '',
    bold: ''
};
const plainEmphases = Object.keys(plainEmphasisVariants);
const plainDisabledVariants = {
    true: {
        buttonSlot: 'cursor-not-allowed'
    }
};
const plainVariantSlots = {
    buttonSlot: 'vertical-align-middle focus-visible:ring-actionSecondary-12 group inline-flex cursor-pointer flex-row items-center justify-center rounded-md transition focus-visible:outline-none focus-visible:ring-2 ring-offset-2 gap-1',
    textSlot: 'transition group-hover:underline',
    iconSlot: 'transition no-underline hover:no-underline group-hover:no-underline'
};
const plainCompoundVariants = [
    {
        emphasis: 'regular',
        type: 'primary',
        class: {
            buttonSlot: 'text-actionPrimary-8 hover:text-actionPrimary-9'
        }
    },
    {
        emphasis: 'regular',
        type: 'secondary',
        class: {
            buttonSlot: 'text-actionSecondary-13 hover:text-actionSecondary-4'
        }
    },
    {
        emphasis: 'regular',
        type: 'critical',
        class: {
            buttonSlot: 'text-actionCritical-8 hover:text-actionCritical-9'
        }
    },
    {
        emphasis: 'medium',
        type: 'primary',
        class: {
            buttonSlot: 'text-actionPrimary-8 hover:text-actionPrimary-9'
        }
    },
    {
        emphasis: 'medium',
        type: 'secondary',
        class: {
            buttonSlot: 'text-actionSecondary-13 hover:text-actionSecondary-4'
        }
    },
    {
        emphasis: 'medium',
        type: 'critical',
        class: {
            buttonSlot: 'text-actionCritical-8 hover:text-actionCritical-9'
        }
    },
    {
        emphasis: 'bold',
        type: 'primary',
        class: {
            buttonSlot: 'text-actionPrimary-1 hover:text-actionPrimary-1'
        }
    },
    {
        emphasis: 'bold',
        type: 'secondary',
        class: {
            buttonSlot: 'text-actionSecondary-1 hover:text-actionSecondary-1'
        }
    },
    {
        emphasis: 'bold',
        type: 'critical',
        class: {
            buttonSlot: 'text-actionCritical-1 hover:text-actionCritical-1'
        }
    },
    {
        disabled: true,
        class: {
            buttonSlot: 'text-actionPrimary-6 hover:text-actionPrimary-6',
            textSlot: 'group-hover:no-underline'
        }
    },
    {
        emphasis: 'bold',
        disabled: true,
        class: {
            buttonSlot: 'text-actionPrimary-1/40 hover:text-actionPrimary-1/40'
        }
    }
];
const plainDefaultVariants = {
    type: 'secondary',
    emphasis: 'regular',
    textStyle: 'body2'
};
export { plainCompoundVariants, plainDefaultVariants, plainDisabledVariants, plainEmphases, plainEmphasisVariants, plainTextStyleVariants, plainTextStyles, plainTypeVariants, plainTypes, plainVariantSlots };
